"use client";

import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBlog } from "@fortawesome/free-solid-svg-icons";
import Link from "next/link";
import useOneArticle from "../../../../lib/hooks/OneArticleCosmic";
import Markdown from "react-markdown";
import { formatDate } from "../../../../lib/utils/dateUtils";

export default function BlogDetailClient({ params }) {
  const { id } = params; // Suppression de slug car non utilisé

  // Utilisation du hook personnalisé
  const { article, loading, error } = useOneArticle(id);

  // Afficher un loader pendant le chargement
  if (loading) {
    return (
      <main id="main" className=" mx-10 px-4 my-10">
        <div className="text-center w-full">
          <p>Chargement de l&apos;article...</p>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main id="main" className=" mx-10 px-4 my-10">
        <div className="text-center w-full">
          <p>Erreur: {error}</p>
        </div>
      </main>
    );
  }

  if (!article) {
    return (
      <main id="main" className=" mx-10 px-4 my-10">
        <div className="text-center w-full">
          <p>Article non trouvé</p>
        </div>
      </main>
    );
  }

  return (
    <div className=" mx-10 px-4 my-10">
      <div className="flex">
        <main id="main">
          <div className="breadcrumbs text-sm width-full">
            <ul>
              <li>
                <Link href="/">Accueil</Link>
              </li>
              <li>
                <Link href="/blog">Blog</Link>
              </li>
              <li>{article.title}</li>
            </ul>
          </div>

          <div className="text-left">
            <h1 className="text-4xl text-left my-5 flex items-center justify-left">
              <FontAwesomeIcon
                icon={faBlog}
                className="w-12 h-12 p-2 mr-2 ml-0"
              />
              {article.title}
            </h1>

            <div className="italic mb-4">
              {formatDate(article.metadata?.date_de_publication)}
              {article.metadata?.theme &&
                article.metadata.theme.map((theme, index) => (
                  <span
                    key={index}
                    className="badge badge-outline capitalize ml-3">
                    {theme.title}
                  </span>
                ))}
            </div>

            {article.metadata?.image?.url && (
              <div className="my-6 md:float-left mr-4">
                <img
                  src={article.metadata.image.url}
                  alt={
                    article.metadata?.image?.alternativeText || article.title
                  }
                  className="max-w-full h-auto"
                  style={{ maxWidth: "400px" }}
                  height={300}
                  width={400}
                />
              </div>
            )}
          </div>

          <div className="prose prose-lg mx-auto blogArticleDetail">
            <Markdown>{article.metadata?.texte || ""}</Markdown>
          </div>

          {article.metadata?.hashtag && (
            <div className="italic my-4 text-center">
              {article.metadata.hashtag}
            </div>
          )}

          <div className="text-center mt-10">
            <Link
              href="/blog"
              className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
              Retour au blog
            </Link>
          </div>
        </main>
      </div>
    </div>
  );
}

// Validation des props
BlogDetailClient.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
